(function($){
    $(document).on('click', '.js-startus-chat-open', function(e) {
        e.preventDefault();
        var $window = $(this).closest('.startus-chat');

        $window.addClass('startus-chat--open');
    });

    $(document).on('click', '.js-startus-chat-close', function(e) {
        e.preventDefault();
        var $window = $(this).closest('.startus-chat');

        $window.removeClass('startus-chat--open');
    });

})(jQuery);
